import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const DrawCreditCardIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7ZM4 11V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V11H4ZM20 9H4V7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7V9ZM6 13C6 12.4477 6.44772 12 7 12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14H7C6.44772 14 6 13.5523 6 13Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

DrawCreditCardIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(DrawCreditCardIcon);
